import { put, takeLatest, call, select } from 'redux-saga/effects';
import { serializeKeys } from '@iso/lib/helpers/keyNormalizer';
import request from '@iso/lib/helpers/httpClient';
import * as actions from './actions';
import * as auth from '@iso/redux/auth/constants';

function* fetchRemoteRemoteConfiguration(_action) {
  const { isAuthenticated } = yield select((state) => state.Auth);

  try {
    const data = yield call(
      request,
      '/configuration',
      'GET',
      null,
      isAuthenticated
    );
    yield put(actions.fetchRemoteConfigurationSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(actions.fetchRemoteConfigurationFail(error));
  }
}

export default function* remoteRemoteConfigurationSaga() {
  yield takeLatest(
    [
      auth.START_WITH_TOKEN_SUCCESS,
      auth.START_WITHOUT_TOKEN,
      auth.SIGNOUT,
      auth.SIGNIN_SUCCESS
    ],
    fetchRemoteRemoteConfiguration
  );
}
